import { applyTheme, useThemeMode } from '@sohanscript/theme/store';
import * as React from 'react';

export function ThemeSync() {
	const mode = useThemeMode();

	React.useEffect(() => {
		applyTheme(mode);
		if (mode !== 'auto') return;
		const media = window.matchMedia('(prefers-color-scheme: dark)');
		const onPreferenceChange = () => applyTheme('auto');
		media.addEventListener('change', onPreferenceChange);
		return () => media.removeEventListener('change', onPreferenceChange);
	}, [mode]);

	return null;
}
